<template functional>
  <a :href="`tel:${props.phoneNumber}`" :class="[data.class, data.staticClass]">
    {{ props.phoneNumber }}
  </a>
</template>

<script>
export default {
  name: 'PhoneLink',
  props: {
    phoneNumber: {
      type: String,
      required: true,
    },
  },
};
</script>
